import { memo } from 'react';
import PropertyInputEnum from './PropertyInputEnum';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputRequiredEnumShim = props => {
  return /*#__PURE__*/_jsx(PropertyInputEnum, Object.assign({}, props, {
    isRequired: true
  }));
};
export default /*#__PURE__*/memo(PropertyInputRequiredEnumShim);